import { GridController } from '../../../../common/grid/grid.controller';
import watch from 'redux-watch';

/* @ngInject */
export function SafetyPlanDocumentLocationsGridController($controller, $ngRedux, $state, $stateParams, NavigationService, Notifier, SafetyPlanActions, SafetyPlanService) {
    var ctrl = this;
    var onSwitch = angular.noop;

    Object.setPrototypeOf(ctrl, new GridController($ngRedux, $state, NavigationService));

    ctrl.$onInit = function() {
        ctrl.module = 'safetyPlan';

        const documentId = $stateParams.documentId;

        ctrl.identifier = 'safetyPlanDocumentLocationsGrid';
        ctrl.filterComponent = false;
        ctrl.exportComponent = false;

        ctrl.columns = [
            {title: '#',                      mapper: null},
            {title: 'Assign/Resign',          mapper: 'checkbox', identifier: this.identifier},
            {title: 'Location',               mapper: 'locationName'}
        ];

        ctrl.unsubscribe = $ngRedux.connect(ctrl.mapState().bind(ctrl), SafetyPlanActions)(ctrl);
        ctrl.dataAction = ctrl.getDocumentLocations;

        var watchGrid = watch($ngRedux.getState, ctrl.module + '.' + ctrl.identifier + '.changedItem');
        onSwitch = $ngRedux.subscribe(watchGrid(function(item) {
            if (item.checked == 1) {
                SafetyPlanService.assignDocumentLocation(item.id, documentId);
                Notifier.success('Location is assigned');
            } else {
                SafetyPlanService.resignDocumentLocation(item.id, documentId);
                Notifier.success('Location is resigned');
            }
        }));

        ctrl.init.call(ctrl);
    };

    ctrl.$onDestroy = function() {
        onSwitch();
        ctrl.destroy();
    };
}
